import { isPlatformBrowser } from '@angular/common';
import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-trustbox-testimonials-desktop',
  templateUrl: './trustbox-testimonials-desktop.component.html'
})
export class TrustboxTestimonialsDesktopComponent implements OnInit {
  public isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (!this.isBrowser) return;
    const trustboxRef = document.getElementById('trustbox-testimonials-desktop');
    window.Trustpilot.loadFromElement(trustboxRef);
  }
}
